import { Controller } from '@hotwired/stimulus'

// Grays out and clears a sub-field when its paired checkbox is unchecked.
// Each checkbox carries data-field="<target-name>" pointing to its sub-field target.
// Usage:
//   checkbox: data-action="change->health-facilities--social-history#toggle"
//             data-field="cigarettePacks"
//   input:    data-health-facilities--social-history-target="cigarettePacks"
export default class extends Controller {
  static targets = ['cigarettePacks', 'bottlesPerDay']

  connect() {
    this.checkboxTargets.forEach(cb => this.#apply(cb, false))
  }

  toggle(event) {
    this.#apply(event.currentTarget, true)
  }

  get checkboxTargets() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"][data-field]'))
  }

  #apply(checkbox, shouldClear) {
    const fieldName = checkbox.dataset.field
    const field = this[`${fieldName}Target`]
    const enabled = checkbox.checked
    if (!enabled && shouldClear) field.value = ''
    field.readOnly = !enabled
    field.required = enabled
    field.classList.toggle('opacity-50', !enabled)
    field.classList.toggle('bg-gray-100', !enabled)
    field.classList.toggle('cursor-not-allowed', !enabled)
  }
}
